import { css } from 'lit';

export const style = css`
  refi-heading {
    margin-bottom: 1em;
  }

  .header {
    margin-bottom: 0.25em;
  }
`;
